import $ from 'jquery'
import _ from 'lodash'
import 'jquery-ujs'

window.jQuery = $
window.$ = $
window._ = _

$.rails.href = function(element) {
  return element.data('href') || element[0].href;
};

import '../widgets/countdown'
import '../components/font-awesome'
import '../components/xhrml'
import '../superhero'

$(document).on('change', 'input[name="user[preferred_exchange]"]', () => {
  var checked = $('input:checked[name="user[preferred_exchange]').val()
  $('.form-group.user_preferred_orbit_exchange_url').toggleClass('d-none', checked !== 'orbit')
})
